import { createVisitPrescriptionSchedule } from '../calendarVisitSchedule.schema';

/**
 * Normalizes an array of prescriptions grouped by padVisitId.
 * Each visit contains its own normalized collection of prescriptions.
 */
export const normalizeVisitPrescriptionSchedule = visitPrescriptionScheduleArray => {
  const byPadVisitId = {};
  visitPrescriptionScheduleArray.forEach(visitPrescriptionSchedule => {
    const { id = null } = visitPrescriptionSchedule.padVisit || {};

    if (id) {
      byPadVisitId[id] = createVisitPrescriptionSchedule(visitPrescriptionSchedule);
    }
  });
  return {
    ids: Object.keys(byPadVisitId).map(Number),
    byPadVisitId
  };
};
